var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankSymbol5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 9,
    viewBox: "0 0 4 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_510_29706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.688477 1.39893V7.35984",
    stroke: "#B3B7C5",
    strokeWidth: 1.0537,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.31421,
    y: 0.616211,
    width: 1.6257,
    height: 2.70951,
    rx: 0.210739,
    fill: "#B3B7C5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.37427,
    y: 5.67383,
    width: 1.6257,
    height: 2.70951,
    rx: 0.210739,
    fill: "#B3B7C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_510_29706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankSymbol5);
export default __webpack_public_path__ + "static/media/bank_symbol-5.734989f954da916737367be3f6506c5c.svg";
export { ForwardRef as ReactComponent };